import { useForm, yupResolver } from "@";

// Hook for form handling with validation
export const useCustomForm = (defaultValues, validationSchema) => {
  const formMethods = useForm({
    defaultValues,
    resolver: validationSchema ? yupResolver(validationSchema) : undefined,
  });

  const {
    reset,
    watch,
    control,
    setValue,
    setFocus,
    register,
    getValues,
    trigger,
    clearErrors,
    handleSubmit,
    formState: { errors, isSubmitSuccessful, isSubmitting },
  } = formMethods;

  return {
    reset,
    watch,
    errors,
    control,
    setValue,
    setFocus,
    register,
    getValues,
    trigger,
    clearErrors,
    handleSubmit,
    isSubmitting,
    isSubmitSuccessful,
  };
};
